
import { Component, Vue } from 'vue-property-decorator'
import { getList } from '@/api/admin'
import { Form as ElForm } from 'element-ui'
import { addCardAccount } from '@/api/product/cardAccount'

@Component({
  name: 'addCardAccount',
  components: {}
})
export default class extends Vue {
  private infoForm: any = {
    name: '',
    manager_id: ''
  }
  private flag: boolean = false
  private managerList: any = []
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  // 获取卡商管理员列表
  private async getCardManagerList() {
    const data = {
      manager_type: 'card_manager'
    }
    await getList(data).then((res: any) => {
      this.managerList = res.results
    })
  }

  private back() {
    this.$emit('close', false)
  }

  private create() {
    ;(this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.flag = true
          await addCardAccount(this.infoForm).then(() => {
            this.$message({
              message: 'Create successful!',
              type: 'success'
            })
            this.flagStr()
            this.back()
          })
        } catch (error) {
          this.flagStr()
          this.back()
        }
      } else {
        return false
      }
    })
  }
  mounted() {
    this.getCardManagerList()
  }
}
